<template>
  <div class="creditorDetail_warpper" ref="creditorDetail_warpper">
    <nav-bar titleText="解债订单" @goBack="goBack" ></nav-bar>
    <div class="content1" ref="creditor">

      <div class="content-box">
        <div class="payment_status-box" v-if="dataSource.status===60 || dataSource.status===130">
          <div
            class="payment_status"
          >{{titleText}}·{{dataSource.repayment_period}}/36期</div>
          <div class="paymentBox">
            <span class="has_payment">¥{{dataSource.repayment_money}}</span>
            <span class="total_amount">/¥{{this.amount}}</span>
          </div>
          <van-progress v-if="dataSource.status===60"
            stroke-width="6"
            track-color="#FEEEE8"
            :show-pivot="false"
            pivot-text
            pivot-color="transparent"
            color="#FC740C"
            :percentage="percentage"
          />
        </div>
        <div class="detail_title" v-if="dataSource.status!==60 && dataSource.status!==130">{{process_status}}</div>
        <van-row class="introduce_row">
        <van-col class="debtor_introduce" span="10">
          <div class="introduceBody">
            <p class="introduce_type">债务人</p>
            <p class="introduce_name">{{ is_supplement== 1 ? (dataSource && dataSource.debtor_name) : (dataSource.dtl && dataSource.dtl.member_realname ) | formatName}}</p>
            <p class="introduce_tel">{{(dataSource.dtl && dataSource.dtl.member_mobile) || (dataSource && dataSource.debtor_mobile)}}</p> 
            <p class="introduce_code">{{code}}</p>
          </div>
        </van-col>
        <van-col class="process" span="4">
          <div class="processBody">
            <p class="reimbursement">还款</p>
            <div class="process_icon">
              <van-icon class="phase" name="play" :style="{ color: '#b3b0b0'}" />
              <van-icon class="phase" name="play" :style="{ color: '#848181'}" />
              <van-icon class="phase" name="play" :style="{ color: '#3a3939'}" />
            </div>
          </div>
        </van-col>
        <van-col class="creditors_introduce" span="10">
          <div class="creditorsBody">
            <p class="introduce_type">债权人</p>
            <p class="introduce_name">{{is_supplement== 1 ? (dataSource && dataSource.creditor_name) :(dataSource.creditor_details && dataSource.creditor_details.member_realname)
              }}</p>
            <p class="introduce_tel">{{(dataSource.creditor_details && dataSource.creditor_details.member_mobile )
              || (dataSource && dataSource.creditor_mobile)}}</p>
            <p class="introduce_code">{{IDCard}}</p>
          </div>
        </van-col>
      </van-row>

      </div>

      <div
        class="viewEleContract"
        v-if="(dataSource.status===60 || dataSource.status===130 || dataSource.status===120)"
        @click="handlElectroniContract()"
      >查看电子合同</div>
      <div class="order_details">
        <p class="order_title">订单详情 <span class="red-text" v-show="is_supplement == 1">(补录)</span> </p>
        <p class="order_content">解债金额 ¥{{this.amount}}</p>
        <p class="order_content" style="color: #999">(包含本金￥{{dataSource.amount}}、利息￥{{dataSource.interest_amount}})</p>
        <p class="order_content">减免债务金额 ¥{{dataSource.reduction_amount}}</p>
        <p :class="[['10'].includes(dataSource.status) ? 'color_333' : 'color_org']">需偿还债务金额 ¥{{needRepaymentMoney}}</p>
        <p class="order_content">经纪人代码 {{dataSource.agent_code}}</p>
        <!-- <p class="order_content">订单号 {{dataSource.order_sn}}</p> -->
        <div class="ordersn">
          <div class="left">
            <span>订单号&nbsp;</span>
            <span ref="copytxt">{{dataSource.order_sn}}</span>
          </div>
          <span class="right" @click="copyOrdersn">复制</span>
        </div>
        <p class="order_content" v-show="is_supplement == 0">创建订单时间 {{dataSource.created_at}}</p>
        <p class="order_content" v-if="dataSource.creditor_confirm_time  && is_supplement == 0" >债权人确认时间 {{dataSource.creditor_confirm_time}}</p>
        <p class="order_content" v-if="dataSource.debtor_confirm_time  && is_supplement == 0" >债务人确认时间 {{dataSource.debtor_confirm_time}}</p>
        <p class="order_content" v-if="[30, 40, 50, 60, 85, 90, 100, 110,120, 130].includes(dataSource.status) && is_supplement == 0">平台审核通过时间 {{dataSource.platform_adopt_time}}</p>
        <p class="order_content" v-if="[40, 50, 60, 90, 100, 110, 120,130].includes(dataSource.status) && is_supplement == 0">财务审核通过时间 {{dataSource.finance_adopt_time}}</p>
        <p class="order_content" v-if="[50, 60, 100, 110, 120,130].includes(dataSource.status) && is_supplement == 0">合同审批通过时间 {{dataSource.contract_adopt_time}}</p>
        <p class="order_content" v-if="[60,120,130].includes(dataSource.status) && is_supplement== 0">合同签署完成时间 {{dataSource.effect_time}}</p>
        <p class="order_content" v-if="[60,130].includes(dataSource.status) && is_supplement== 1">合同签署完成时间 {{dataSource.contract_sign_time}}</p>
        <p class="order_content" v-if="[130].includes(dataSource.status) && is_supplement== 1">债权回收完成时间 {{dataSource.debt_complete_time}}</p>
        <p class="order_content" v-if="[70].includes(dataSource.status)">债权人驳回时间 {{dataSource.creditor_reject_time}}</p>
        <p class="order_content" v-if="[75].includes(dataSource.status)">债务人驳回时间 {{dataSource.debtor_reject_time}}</p>
        <p class="order_content" v-if="[80].includes(dataSource.status)">平台驳回时间 {{dataSource.platform_reject_time}}</p>
        <p class="order_content" v-if="[85].includes(dataSource.status)">财务驳回时间 {{dataSource.platform_reject_time}}</p>
        <p class="order_content" v-if="[90].includes(dataSource.status)">合同驳回时间 {{dataSource.platform_reject_time}}</p>
        <p class="order_content" v-if="[100].includes(dataSource.status)">合同撤回时间 {{dataSource.contract_revoke_time}}</p>
        <p class="order_content" v-if="[110].includes(dataSource.status)">合同失效时间 {{dataSource.contract_expire_time}}</p>
        <!-- 合同作废显示时间 -->
        <p class="order_content" v-if="[120].includes(dataSource.status)">合同作废时间 {{dataSource.contract_void_time}}</p>
        <!-- 合同作废显示时间 -->
        <p class="order_content" v-if="[70].includes(dataSource.status)" >驳回理由<span class="font-ew"> {{ dataSource.creditor_reject_remark}}</span></p>
        <p class="order_content" v-if="[75].includes(dataSource.status)" >驳回理由<span class="font-ew"> {{ dataSource.debtor_reject_remark}}</span></p>
        <p class="order_content" v-if="[80].includes(dataSource.status)" >驳回理由<span class="font-ew"> {{ dataSource.platform_reject_remark}}</span></p>
        <p class="order_content" v-if="[85].includes(dataSource.status)" >驳回理由<span class="font-ew"> {{ dataSource.platform_reject_remark}}</span></p>
        <p class="order_content" v-if="[90].includes(dataSource.status)" >驳回理由<span class="font-ew"> {{ dataSource.platform_reject_remark}}</span></p>
        
        <div v-if="[10,13, 20, 23, 25, 30, 40, 50, 60, 75,80,85,90,100,110,120,130].includes(dataSource.status)"  :class="{'upload-box-wrapper1': dataSource.status == 20}">
        <!-- <div v-if="true" > -->
          <div class="upload-box-1">
            <p class="order_content p1" v-if="[13,20, 23, 25, 30, 40, 50, 60,75,80,85,90,100,110,120,130].includes(dataSource.status) && ((is_supplement== 0) || (is_supplement == 1 && fileList.length))" style="padding-bottom: 2px;padding-top: 15px;">借据凭证</p>
            <p class="order_content p2" v-if="[13,20, 23, 25, 30, 40, 50, 60,75,80,85,90,100,110,120,130].includes(dataSource.status)  && ((is_supplement== 0) || (is_supplement == 1 && fileList.length))" style="padding-bottom: 15px; color: #999">包括借条、转账记录截图、法院调解书或者判决书、承诺函等</p>

            <div v-if="[13,20, 23, 25, 30, 40, 50, 60,75,80,85,90,100,110,120,130].includes(dataSource.status)  && ((is_supplement== 0) || (is_supplement == 1 && fileList.length))" class="uploadBox upload1" :style="uploadBoxStyle">
              <!--upload_title 上传凭证-->
              <van-uploader 
                v-model="fileList" 
                multiple 
                :max-count="uploadMax" 
                :deletable="uploadDeletable"
                :preview-size="img_height"
                @oversize="onOversize"
                @delete="deleteFile1"
                :after-read="afterRead1"
                :before-read="beforeRead"
              >
                <div class="box" :style="boxStyle">
                  <div class="icon">+</div>
                  <div class="title">上传借据凭证</div>
                </div>
              </van-uploader>
            </div>
          </div>

          <!-- 二期新增 -->
          <p class="order_content p3" v-if="[10, 20, 25, 30, 40, 50, 60,70,80,85,90,100,110,120,130].includes(dataSource.status) && ((is_supplement== 0) || (is_supplement == 1 && fileList_2.length))" style="color: #999">打款凭证</p>
          <div class="uploadBox" :style="uploadBoxStyle" v-if="[10, 20, 25, 30, 40, 50, 60,70,80,85,90,100,110,120,130].includes(dataSource.status) && ((is_supplement== 0) || (is_supplement == 1 && fileList_2.length))">
            <!--upload_title 打款凭证--> 
            <van-uploader 
              v-model="fileList_2" 
              multiple 
              :max-count="uploadMax_2" 
              :deletable="uploadDeletable_2"
              :preview-size="img_height"
              @oversize="onOversize"
              @delete="deleteFile2"
              :after-read="afterRead2"
              :before-read="beforeRead"
            >
              <div class="box" :style="boxStyle">
                <div class="icon">+</div>
                <div class="title">打款凭证</div>
              </div>
            </van-uploader>
          </div>
        </div>
        <div :class="{'empty-placehoder': dataSource.status == 20}"></div>
        <div class="operation-box" :class="{'operation-box1': dataSource.status == 20}" v-if="operationObj.operation1_btn || operationObj.operation2_btn">
          <div v-if="operationObj.operation1_btn" class="operation">
            <van-button
              v-if="operationObj.operation1_btn"
              type="primary"
              :loading="operation_loading"
              class="operation_btn"
              @click="handleClick(operationObj.type)"
            >{{operationObj.operation_text}}</van-button>
          </div>
          <div v-if="operationObj.operation2_btn" class="rejected">
            <van-button
              v-if="operationObj.operation2_btn"
              type="primary"
              @click="handleRejected(operationObj.reject)"
              class="operation_btn"
            >{{operationObj.callBack}}</van-button>
          </div>
        </div>
      </div>
      <div class="dialog1">
        <van-dialog
          v-model="show"
          title="确认驳回"
          show-cancel-button
          confirm-button-color="#F9591B"
          :before-close="beforeClose"
        >
          <div class="modalBody">
            <p>请填写驳回理由</p>
            <textarea
              :maxlength="sum_text"
              placeholder="请输入..."
              ref="description"
              @keyup="wordlimit()"
            ></textarea>
            <span>{{this.number}}/{{this.sum_text}}</span>
          </div>
        </van-dialog>
      </div>

      <div class="dialog2">
        <van-dialog
          v-model="showDialog2"
          title="提示"
          message="确认通过此解债订单？"
          confirm-button-text="确认"
          confirm-button-color="#F9591B"
          cancel-button-text="取消"
          cancel-button-color="#999999"
          @confirm="confirmEvent"
          show-cancel-button
        >
        </van-dialog>
      </div>
      <div class="loading5" v-if="loading5">
        <img src="../../../assets/common/loading.gif"/>
      </div>
      <!-- <div class="recycling" v-if="[1, 2].includes(dataSource.repayment_status) && [60, 130].includes(dataSource.status)"> -->
        <!-- 60 130 状态 2020.04.25产品要求隐藏下面红包隐藏 -->
      <!-- <div class="recycling" v-if="[60, 130].includes(dataSource.status)">
        <van-tabs v-model="active">
          <van-tab title="待回收" v-if="dataSource.status == 60">
            <van-pull-refresh v-model="refreshing1" @refresh="onRefresh1">
              <van-list
                v-model="loading1"
                :finished="finished1"
                :finished-text="this.list1.length === 0 ? '' : '没有更多了'"
                @load="onLoad1"
              >
                <div class="recycledBody" v-for="(item, index) in list1" :key="index">
                  <div class="recycledContent">
                    <van-row class="content_row">
                      <van-col span="14" class="source">{{item.content}}</van-col>
                    </van-row>
                    <van-row>
                      <van-col class="money" span="24">+{{ (is_supplement == 1 && dataSource.status == 60) ? parseFloat(item.money).toFixed(4) : parseFloat(item.money).toFixed(2)}}</van-col>
                    </van-row>
                    <van-row>
                      <van-col class="way" span="24">{{item.typeName}}</van-col>
                    </van-row>
                  </div>
                </div>
                <div class="empty" v-if="list1.length === 0">
                  <div class="emptyMsg" span="24">
                    <img src="../../../assets/debtor/empty.png" width="100%" height="100%" />
                    <p class="tip">暂无待回收红包</p>
                  </div>
                </div>
              </van-list>
            </van-pull-refresh>
          </van-tab>
          <van-tab :title="tabTitleText">
            <van-pull-refresh v-model="refreshing2" @refresh="onRefresh2">
              <van-list
                v-model="loading2"
                :finished="finished2"
                :finished-text="this.list2.length === 0 ? '' : '没有更多了'"
                @load="onLoad2"
              >
                <div class="recycledBody" v-for="(item, index) in list2" :key="index"  @click="goDebtMicroCurrencyInfo(item)">
                  <div class="recycledContent">
                    <van-row class="content_row">
                      <van-col span="14" class="source">{{item.content}}</van-col>
                      <van-col span="10" class="time">{{ (is_supplement == 1 && dataSource.status == 60) ? '' : item.createTime}}</van-col>
                    </van-row>
                    <van-row>
                      <van-col class="money" span="24">{{ (is_supplement == 1 && dataSource.status == 60) ? parseFloat(item.coin).toFixed(4) : parseFloat(item.coin).toFixed(2)}}</van-col>
                    </van-row>
                    <van-row>
                      <van-col class="way" span="24">{{item.typeName}}</van-col>
                    </van-row>
                  </div>
                </div>
                <div class="empty" v-if="list2.length === 0">
                  <div class="emptyMsg" span="24">
                    <img src="../../../assets/debtor/empty.png" width="100%" height="100%" />
                    <p class="tip">暂无已回收红包</p>
                  </div>
                </div>
              </van-list>
            </van-pull-refresh>
          </van-tab>
        </van-tabs>
        <p class="check_micro_currency" @click="goDebtMicroCurrencyHome">查看我的红包</p>
      </div> -->
    </div>
  </div>
</template>
<script>
import navBar from "../components/navBar";
import {uploadMixin} from "../mixin"
export default {
  name: "debtorDetail",
  data() {
    return {
      // 新增upload修改  写死99px
      img_height: '99px',
      total_amount: "360000.000", //总还款
      operation_loading: false, //发送请求避免重复提交
      percentage: 0,
      code: "",
      IDCard: "",
      fileList: [],
      fileList1: [],
      fileNameMap: {},
      fileNameMap_2: {},
      fileList_2: [],
      fileList1_2: [],
      upload_file: "",
      receipt_img: "",
      uploadDeletable: false,
      uploadDeletable_2: false,
      number: 0, //已输入驳回字数
      sum_text: 40, //驳回理由总字数限制
      show: false, //显示驳回弹框
      showDialog2: false,
      active: 2,
      token: "",
      process_status: "",
      amount: 0, //还款金额
      needRepaymentMoney: 0,
      operationObj: {
        operation1_btn: false, //是否显示操作按钮1 
        operation2_btn: false, //是否显示操作按钮2
        callBack: "撤回", //查看电子合同/驳回//撤回/查看电子合同/删除订单
        operation_text: "提交", //签署电子合同/提交/通过/签署合同
        type: "", //签署电子合同:electronic_contract
        reject: "", //删除订单delete_creditor
      },
      dataSource: {},
      uploadMax: 8,
      uploadMax_2: 8,
      coin_id:-1,

      page1: 0,
      page_size1: 10,
      list1: [],
      finished1: false,
      loading1: false,
      refreshing1: false,

      page2: 0,
      page_size2: 10,
      list2: [],
      finished2: false,
      loading2: false,
      refreshing2: false,
      id:-1, // 跳转原生查看已回收红包详情的参数

      loading5: false,
      timeId: 0,
      is_supplement:0,
      dataSourcestatus:0
    };
  },
  components: {
    navBar,
  },
  mixins: [uploadMixin],
  created() {
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    this.onLoad();
  },
  mounted() {

  },
  computed: {
    uploadBoxStyle(){
      return !this.operationObj.operation1_btn && !this.operationObj.operation1_btn ? 
      { 'padding-bottom': '16px', 'height': this.img_height} : 
      { 'height': this.img_height }  
    },
    boxStyle(){
      return { width: this.img_height, height: this.img_height }
    },
    tabTitleText(){
      if (this.dataSource.status == 60)  return '已回收'
      if (this.dataSource.status == 130)  return '回收记录'
    },
    titleText(){
      if (this.dataSource.status == 60 || this.dataSourcestatus == 60) {
        if (this.dataSource.repayment_status == 1 || this.dataSourcestatus == 60)  return '债权回收中' 
        if (this.dataSource.repayment_status == 2)  return '已冻结'   // 1：正常，2：冻结
        // return '已冻结'
      }
      if (this.dataSource.status == 130  || this.dataSourcestatus == 130) {
        return '债权回收完成'
      }
    }
  },
  filters: {
    formatName(value) {
      if (value && value.length <= 8) {
        return value
      }
      if (value && value.length > 8) {
        return `${value.slice(0, 7)}...`
      }
    },
  },
  destroyed() {
    clearInterval(this.timeId)
  },
  
  methods: {
    runScroll(){
      if([20].includes(this.dataSource.status)) { 
       const parentDom = this.$refs.creditorDetail_warpper
       const parentHeight = parentDom.offsetHeight
       const sonHeight = this.$refs.creditor.offsetHeight

       const shouldScrollHeight = parentHeight - sonHeight + 88
      
       setTimeout(() => {
         parentDom.scrollTop = shouldScrollHeight
       },500)
      }
    },
    deleteFile1(file){
      this.deleteFile(file, this.fileList1, this.fileNameMap)
    },
    deleteFile2(file){
      this.deleteFile(file, this.fileList1_2, this.fileNameMap_2)
    },
    onLoad1() {
      this.page1++;
      this.getList1();
    },
    onRefresh1() {
      this.page1 = 0;
      this.onLoad1();
    },
    // 待回收
    getList1(){
      this.$api
        .post("debt/member/creditor/creditor-order/wait-recovery", {
          is_supplement:this.$route.query.is_supplement,
          id: this.$route.query.order_id,
          page_size: this.page_size1,
          page_num: this.page1,
        })
        .then((res) => {
          if (this.refreshing1) {
            this.list1 = [];
            this.finished1 = false;
          }
          this.list1.push(...res.list)
          if (this.list1.length === 0 || res.length === 0) {
            this.finished1 = true;
            this.loading1 = false;
            this.refreshing1 = false;
            return;
          }

          this.loading1 = false;
          if (res.current_page === res.last_page) {
            this.finished1 = true;
          }

          if (this.refreshing1) {
            this.$toast("刷新成功");
            this.refreshing1 = false;
          }

          if (!this.finished1 && !this.loading1 && this.list1.length <= 2) {
            this.onLoad();
          }
        })
        .catch((err) => {
          this.loading1 = false;
          this.finished1 = true;
          this.refreshing1 = false
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          }
          return;
        });
    },

    onLoad2() {
      this.page2++;
      this.getList2();
    },
    onRefresh2() {
      this.page2 = 0;
      this.onLoad2();
    },
    getList2(){
      // 已回收请求 
      this.$api
        .post("/coin/member/appCoin/list", {
          coinId: this.coin_id,
          pageSize: this.page_size2,
          pageNum: this.page2,
          type:16,  
        })
        .then((res) => {
          if (this.refreshing2) {
            this.list2 = [];
            this.finished2 = false;
          }
          const _list = res.list.map(item => {
            if (String(item.coin).slice(0,1) != '-') {
              item.coin = parseFloat(item.coin)
              item.coin = '+' + item.coin
            }else {
              item.coin = parseFloat(item.coin)
            }
            return item
          })
          this.list2.push(..._list)
          if (this.list2.length === 0 || res.length === 0) {
            this.finished2 = true;
            this.loading2 = false;
            this.refreshing2 = false;
            return;
          }

          this.loading2 = false;
          if (! res.hasNextPage) {
            this.finished2 = true;
          }

          if (this.refreshing2) {
            this.$toast("刷新成功");
            this.refreshing2 = false;
          }

          if (!this.finished2 && !this.loading2 && this.list2.length <= 2) {
            this.onLoad();
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading2 = false;
          this.finished2 = true;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          }
          return;
        });
    },

    afterRead1(file){
      // if(file.size != 0 && JSON.stringify(file.file) != '{}'){ //解决部分机型取消上传还是添加空白图片
        this._afterRead(file, 'debt', this.fileList, this.fileList1, this.fileNameMap)
      // }
    },
    afterRead2(file){
      // if(file.size != 0 && JSON.stringify(file.file) != '{}'){ //解决部分机型取消上传还是添加空白图片
        this._afterRead(file, 'debt', this.fileList_2, this.fileList1_2, this.fileNameMap_2)
      // }
    },
    handleRecycle2(){

    },
    goBack() {
      if (this.$route.query.debt_from === 'list') {
        this.$router.go(-1)
        return
      }
      this.$router.push('/creditor/creditorView')
    },
    confirmEvent(){
      this.$api
      .post("debt/member/creditor/creditor-order/adopt", {
        // order_id: 2,
        order_id: this.$route.query.order_id,
      })
      .then((res) => {
        this.$toast("审核通过，请上传借据凭证并提交");
        this.operationObj.operation2_btn = false;
        this.operationObj.operation1_btn = false;
        this.onLoad();
      })
      .catch((err) => {
        let keys = Object.keys(err);
        let key = keys[0];
        let message = err.message || err[key][0];
        if (message.slice(0, 10) == "timeout of") { 
          this.$toast("网络不给力，请稍候重试");
        } else {
          // this.$toast(message);
        }
        return;
      });
    },
    handleClick(btn1) {
      switch (btn1) {
        case "electronic_contract":
          this.$router.push({
            path: '/debtor/signContract',
            query: {
              order_id: this.$route.query.order_id,
              contract_id: this.dataSource.contract_id,
              identity: 'creditor',
            }
          })
          break;
        case "through": //通过
          this.showDialog2 = true
          break;
        case "approval": //提交借条
          if (this.fileList.length === 0) { 
            this.$toast("借据不能为空！！！")
            return
          }
          // if (this.fileList.length !== this.fileList1.length) {
          //   this.$toast('请等待借条上传完毕') 
          //   return
          // }

          this.loading5 = true

          // const constTimeout = 60
          // let count = 0
          this.timeId = setInterval(() => {
          //   count ++
          //   if (count >= constTimeout * 1000 / 200) {
          //     this.$toast('提交失败')
          //     clearInterval(timeId)
          //     this.loading5 = false
          //     return
          //   }w

            if (this.fileList.length === this.fileList1.length) {
              clearInterval(this.timeId)
              this.$api
                .post("/debt/member/creditor/creditor-order/up-iou", {
                  order_id: this.$route.query.order_id,
                  receipt_img: this.fileList1,
                })
                .then( (res) => {
                  this.$toast("提交成功");
                  this.uploadMax = 0
                  this.operationObj.operation1_btn = false;
                  this.uploadDeletable = false
                  // this.onLoad();
                  this.$router.push({
                    path: '/creditor/resultSubmitIOU',
                    query: {
                      id: this.dataSource.id
                    },
                  })
                })
                .catch((err) => {
                  console.log(err)
                  err.message && this.$toast(err.message)
                })
                .finally(() => {
                  this.loading5 = false
                })
            }

          },200)



          // this.fileList = this.fileList.map(item => item.url)


          break;
      }
    },
    handleRejected(btn2) {
      switch (btn2) {
        case "delete_creditor": //删除订单跳回到首页
          this.$dialog
            .confirm({
              title: "提示",
              closeOnPopstate: true,
              closeOnClickOverlay: true,
              message: "确认删除此订单？",
              cancelButtonColor: "#333333",
              confirmButtonColor: "#F9591B",
            })
            .then(() => {
              this.$api
                .post("/debt/member/creditor/creditor-order/delete", {
                  id: this.$route.query.order_id,
                })
                .then(res => {
                  this.$toast("删除成功");
                  this.$router.push({
                    path: "/creditor/debtorView",
                  });
                })
                .catch((err) => {
                  this.$toast("当前订单不可删除！");
                  let keys = Object.keys(err);
                  let key = keys[0];
                  let message = err.message || err[key][0];
                  //this.$toast(message);
                  if (message.slice(0, 10) == "timeout of") {
                    this.$toast("网络不给力，请稍候重试");
                  } else {
                    // this.$toast(message);
                  }
                  return;
                });
            })
            .catch(() => {
              // on cancel
            });
          break;
        case "rejected":
          this.show = true; //弹出驳回框

          break;
        case "view_electronic_contracts":
          this.$router.push({
            path: '/debtor/electroniContract',
            query: {
              contract_id: this.dataSource.contract_id,
            },
          })
          break;
      }
    },
    onLoad() {
      this.$api
        .post("debt/member/creditor/creditor-order/details", {
          is_supplement:this.$route.query.is_supplement,
          order_id: this.$route.query.order_id,
          debtor_id: this.$route.query.debtor_id,
        })
        .then((data) => {
          this.is_supplement = data.is_supplement
          this.dataSourcestatus = data.status
          this.dataSource = data;
          this.coin_id = data.coin_id 
          this.amount = (parseFloat(data.amount) + parseFloat(data.interest_amount)).toFixed(2)
          this.needRepaymentMoney = (parseFloat(data.debt_amount) - parseFloat(data.reduction_amount)).toFixed(2)
          this.percentage = (parseFloat(data.repayment_money) / this.amount).toFixed(2) * 100
          this.code = '****' + String(this.dataSource.debtor_id_number || this.dataSource.debtor_credit_code).slice(-4)
          this.IDCard = '****' + this.dataSource.creditor_id_number.slice(-4)
          // 自动滚动到页面底部，看见上传框
          this.runScroll()

          // this.dataSource.status = 60
          if ([13, 23, 25, 30, 40, 50, 60,75,80,85,90,100,110,120,130].includes(this.dataSource.status)) {
            if (Array.isArray(this.dataSource.receipt_img)) {
              this.fileList = []
              this.dataSource.receipt_img.forEach(item => {
                this.fileList.push({
                  url: item,
                  isImage: true,
                })
              })
            }else {
              console.error('服务器返回借据凭证不为数组')
            }
            this.uploadMax = 0
          }
          if ([10, 20, 25, 30, 40, 50, 60,70,80,85,90,100,110,120,130].includes(this.dataSource.status)) {
            if (Array.isArray(this.dataSource.payment_info)) {
              this.fileList_2 = []
              this.dataSource.payment_info.forEach(item => {
                this.fileList_2.push({
                  url: item,
                  isImage: true,
                })
              })
            }else {
              console.error('服务器返回打款凭证不为数组')
            }
            this.uploadMax_2 = 0
          }
          switch (this.dataSource.status) {
            case 10:
              this.process_status = "待债权人确认";
              this.operationObj.operation1_btn = true;
              this.operationObj.operation2_btn = true;
              this.operationObj.operation_text = "通过";
              this.operationObj.callBack = "驳回";
              this.operationObj.type = "through";
              this.operationObj.reject = "rejected";
              break;
            case 13:
              this.process_status = "待债务人确认";
              break;
            case 20:
              this.process_status = "待债权人上传借据凭证";
              this.uploadDeletable = true
              this.operationObj.operation1_btn = true;
              this.operationObj.operation_text = "提交";
              this.operationObj.type = "approval"; //提交借据凭证
              break;
            case 23:
              this.process_status = "待债务人上传打款凭证";
              // this.uploadDeletable = true
              // this.operationObj.operation1_btn = true;
              // this.operationObj.operation_text = "提交";
              // this.operationObj.type = "approval"; //TODO-------------------
              break;
            case 25:
              this.uploadMax = 0
              this.process_status = "待平台审核";
              break;
            case 30:
              this.process_status = "待财务审核";
              break;
            case 40:
              this.process_status = "待合同审批";
              break;
            case 50:
              if (this.dataSource.sign_role === 0 || this.dataSource.sign_role === 2 ) {
                this.process_status = "待合同签名";
                this.operationObj.operation1_btn = true;
                this.operationObj.operation_text = "签署合同";
                this.operationObj.type = "electronic_contract"; //电子签名
              }
              if (this.dataSource.sign_role === 1 ) {
                this.process_status = "等待债务人签署合同";
                this.operationObj.operation2_btn = true;
                this.operationObj.callBack = "查看电子合同";
                this.operationObj.reject = "view_electronic_contracts";
              }
              break;
            case 60:
              this.process_status = "债权回收中";
              break;
            case 70:
              this.process_status = "债权人驳回";
              this.operationObj.operation2_btn = false;
              this.operationObj.callBack = "删除订单";
              this.operationObj.reject = "delete_creditor";
              break;
            case 75:
              this.process_status = "债务人驳回";
              break
            case 80:
              this.process_status = "平台驳回";
              this.operationObj.operation2_btn = false;
              this.operationObj.callBack = "删除订单";
              this.operationObj.reject = "delete_creditor";
              break;
            case 85:
              this.process_status = "财务驳回";
              this.operationObj.operation2_btn = false;
              this.operationObj.callBack = "删除订单";
              this.operationObj.reject = "delete_creditor";
              break;
            case 90:
              this.process_status = "合同审批驳回";
              break;
            case 100:
              this.process_status = "合同撤回";
              break;
            case 110:
              this.process_status = "合同失效";
              break;
              case 120:
              this.process_status = "合同作废";
              break;
            case 130:
              this.process_status = "债权回收完成";
              break;
            default:
              this.process_status = "订单状态异常";
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    beforeClose(action, done) {
      if (action === "confirm") {
        if (!this.$refs.description.value) {
          done(false);
          this.$toast("驳回理由必填哦!");
        }else if (this.$refs.description.value.length <= 2) {
          done(false);
          this.$toast("债权人驳回原因长度必须大于2");
        }else {
          this.handleConfirm();
          done();
        }
      } else {
        done();
      }
    },
    handleConfirm() {
      this.$api
        .post("debt/member/creditor/creditor-order/reject", {
          order_id: this.$route.query.order_id,
          creditor_reject_remark: this.$refs.description.value,
        })
        .then((res) => {
          this.operationObj.operation1_btn = false;
          this.operationObj.operation2_btn = false;
          this.onLoad();
        })
        .catch((err) => {
          console.log(err)
          this.$toast(err.message || '服务器错误')
        });
    },
    // TODO 跳转原生 查看 我的红包 红包首页
    goDebtMicroCurrencyHome() {
      // TODO 参数确认
      const param = {}
      this.params(
        JSON.stringify(param),
        JSON.stringify(param),
        'debtMicroCurrencyHome',
      )
    },
    // TODO 跳转原生 查看 红包详情
    goDebtMicroCurrencyInfo(item) {
      // TODO 参数确认
      const param = {
        id: item.id
       }
      this.params(
        JSON.stringify(param),
        JSON.stringify(param),
        'debtMicroCurrencyInfo',
      )
    },
    // handleRejected() {

    // this.$dialog
    //   .confirm({
    //     title: "确认驳回",
    //     message: `<div  class="modalBody"><p>请填写驳回理由</p><textarea  maxlength="5"  placeholder="请输入..." ref="description" @keyup="wordlimit"></textarea><span>${this.number}/40</span></div>`,
    //     cancelButtonColor: "#333333",
    //     confirmButtonColor: "#F9591B",
    //   })
    //   .then(() => {
    //     this.$router.go(-1);
    //   })
    //   .catch(() => {});
    // },
    // 限制输入字数
    wordlimit() {
      let textVal = this.$refs.description.value;
      this.number = textVal.length;
      let length;
      length = parseInt(this.sum_text) - parseInt(textVal.length);
      if (length < 0) {
        length = 0;
      }
      this.limit = length;
      if (textVal.length >= this.sum_text) {
        this.$refs.description.value = textVal.substring(0, this.sum_text);
      }
    },
    //查看电子合同
    handlElectroniContract() {
      this.$router.push({
        path: '/debtor/electroniContract',


        query: {
          contract_id: this.dataSource.contract_id,
          is_supplement:this.is_supplement,
          order_id: this.$route.query.order_id,
        },
      });
    },
    reBack() {
      this.$router.go(-1);
    },
    copyOrdersn(){
        const creditor_range = document.createRange();
        creditor_range.selectNode(this.$refs.copytxt);
        const creditor_selection = window.getSelection();
        if(creditor_selection.rangeCount > 0) creditor_selection.removeAllRanges();
        creditor_selection.addRange(creditor_range);
        document.execCommand('Copy');
        this.$toast('复制成功')
        creditor_selection.removeAllRanges()
    },
  },
};
</script>
<style lang="less">
.creditorDetail_warpper {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  &::-webkit-scrollbar {
    display: none;
  }
  overflow-y: auto;

  padding-top: 88px;
  background-color: #f5f6f7;
  color: #333333;
  // .navbar {
  //   margin: 24px 5px 0 5px;
  // }
  .content1 {
    // margin: 12px;
    .payment_status-box {
      padding: 0 6px;
    }
    .payment_status {
      font-size: 15px;
      height: 30px;
      line-height: 30px;
    }
    .paymentBox {
      margin: 9px 0 15px;
    }
    .has_payment {
      font-size: 24px;
      font-weight: 600;
    }
    .total_amount {
      font-size: 16px;
      color: #999999;
    }
    .van-progress {
      background: rgb(254, 238, 232);
      height: 6px;
      width: 100%;
    }
    .content-box {
      padding: 12px 12px 0;
      background: linear-gradient(360deg, #F5F6F7 0%, #FFFFFF 100%);
    }
    .detail_title {
      font-size: 24px;
      font-weight: 600;
      margin: 18px 0 24px 0;
    }
    .introduce_row {
      margin-bottom: 12px;
      margin-top: 15px;
    }
    .introduceBody,
    .creditorsBody {
      background-color: #fff;
      width: 100%;
      height: 139px;
      -webkit-box-shadow: 0px 0px 1px #000;
      box-shadow: 0px 0px 4px #dedada;
      text-align: center;
      border-radius: 6px;
      .introduce_type {
        color: #999999;
        font-size: 13px;
        padding: 15px 0 6px;
      }
      .introduce_name {
        color: #fc740c;
        font-size: 17px;
        height: 28px;
        font-weight: 600;
        line-height: 28px;
      }
      .introduce_tel {
        font-size: 15px;
        margin: 3px 0;
        height: 24px;
        line-height: 24px;
      }
      .introduce_code {
        color: #999999;
        font-size: 15px;
        padding-bottom: 14px;
        height: 24px;
        line-height: 24px;
      }
    }
    .process {
      text-align: center;
      // height: 150px;
      .processBody {
        margin-top: 52px;
        .reimbursement {
          font-size: 15px;
        }
        .process_icon {
          .phase {
            width: 12px;
            height: 12px;
            margin: 6px 0px 0 0;
          }
        }
      }
    }
    .order_details {
      margin: 1px 12px 0;
      // padding-bottom: 6px;
      background-color: #fff;
      font-size: 14px;
      border-radius: 6px;
      // padding-bottom: 6px;
      .order_title {
        color: #999999;
        padding: 15px 0 10px;
        margin-left: 15px;
      }
      .order_content {
        // padding-bottom: 3px;
        font-size: 15px;
        padding: 3px 0;
        margin-left: 15px;
        margin-right: 15px;
        // height: 23px;
        line-height: 23px;
        &:nth-last-of-type(1) {
          padding-bottom: 0;
        }
        .font-ew{
          font-weight: 600;
        }
      }
      .color_org {
        color: #f9591b;
        padding: 3px 0;
        margin-left: 15px;
        height: 23px;
        line-height: 23px;
      }
      .color_333 {
        color: #333;
        padding: 3px 0;
        margin-left: 15px;
        height: 23px;
        line-height: 23px;
      }
      .ordersn {
        display: flex;
        justify-content: space-between;
        padding: 3px 0;
        align-content: center;
        .left {
          margin-left: 15px;
          height: 23px;
          line-height: 23px;
        }
        .right {
          height: 23px;
          font-size: 14px;
          color: #F9591B;
          line-height: 23px;
          padding-right: 15px;
        }
      }
      .uploadBox {
        margin: 0 15px 0 15px;
        // padding-bottom: 16px;
        // min-height: 80px;

        // 新增upload修改
        overflow-x: auto;
        overflow-y: hidden;

        .box {
          // width: 80px;
          // height: 80px;
          border: 1px dashed #dedede;
          box-sizing: border-box;
          .icon {
            text-align: center;
            color: #999999;
            height: 21px;
            line-height: 21px;
            margin: 27px 0 9px;
            font-size: 35px;
          }
          .title {
            text-align: center;
            font-size: 13px;
            height: 21px;
            line-height: 21px;
            color: #555555;
          }
        }
      }
      p {
        .van-uploader__preview-image {
          width: 100px;
          height: 100px;
        }
      }
      .operation-box {
        background-color: #ffffff;
        // width: calc(100% - 24px);
        width: 100%;
        padding: 0  15px 24px;
        margin-top: 24px;
        box-sizing: border-box;
        border-radius: 4px;
        // position: fixed;
        // bottom: 0;
      }
      .operation-box1 {
        background-color: #f5f6f7;
        padding-top: 212px;
        .operation {
          margin: 0;
        }
      }
      .operation {
        box-sizing: border-box;
        width: 100%;
        margin: 0 0 15px;
        .operation_btn {
          background-color: #fc740c;
          color: #fff;
          border: none;
        }
      }
      .rejected {
        width: 100%;
        // margin: 0 15px;
        .operation_btn {
          background-color: #fff;
          color: #333;
          border: 1px solid #666;
        }
      }
      .operation_btn {
        box-sizing: border-box;
        width: 100%;
        /* margin: 24px 15px; */
        height: 50px;
        font-size: 17px;
        display: block;
        border-radius: 30px;
        line-height: 50px;
        font-weight: 600;
      }
      .p3 {
        padding: 15px 0 6px !important;
      }
      .upload-box-wrapper1 {
        position: relative;
        padding-bottom: 24px;
        .upload-box-1 {
          padding-bottom: 24px;
          background-color: #fff;
          position: absolute;
          top: 180px;
          left: 0;
          width: 100%;
          .p1 {

          }
          .p2 {

          }
          .upload1 {

          }
        }
        .p3 {
          padding-top: 15px;
        }
      }

    }

    .recycling {
      margin-top: 24px;
      padding-bottom: 17px;
      position: relative;
      .check_micro_currency {
        position: absolute;
        top: 12px;
        right: 12px;
        font-size: 16px;
        color: #f9591b;
        font-weight: 600;
      }
      .van-tabs__wrap.van-hairline--top-bottom {
        padding-left: 15px;
      }
    }
    .van-tabs--line .van-tabs__wrap {
      height: 36px;
      width: 34%;
      margin-left: -10px;
    }
    .van-tabs__nav {
      background-color: #f5f6f7;
    }
    .van-tabs__line {
      width: 45px !important;
      background-color: #f9591b;
      // transform: translateX(30px) translateX(-50%)!important;
    }
    .recycledBody {
      overflow-y: scroll;
      margin: 0 12px; 
    }
    .recycledContent {
      background-color: #fff;
      padding: 15px 18px;
      margin-top: 12px;
      border-radius: 10px;
      .content_row {
        margin-bottom: 6px;
        .source {
          font-size: 15px;
          color: #333333;
          height: 24px;
          line-height: 24px;
        }
        .time {
          font-size: 14px;
          color: #999999;
          text-align: right;
        }
      }
      .money {
        font-size: 24px;
        font-weight: 600;
        height: 32px;
        line-height: 32px;
      }
      .way {
        margin-top: 6px;
        height: 24px;
        line-height: 24px;
        color: #999;
      }
    }
  }
  .viewEleContract {
    margin: 4px 12px 0;
    text-align: center;
    height: 36px;
    line-height: 36px;
    background: #fff;
    font-size: 15px;
    box-shadow: 0px 2px 8px 0px rgba(153, 153, 153, 0.11) !important;
    border-radius: 4px 4px 0px 0px;
  }

  .modalBody {
    height: 160px;
    text-align: center;
    p {
      color: #333333;
      font-size: 15px;
      height: 24px;
      line-height: 24px;
      margin: 8px 0 24px;
    }
    textarea {
      resize:none;
      background: #f5f6f7;
      border: none;
      font-size: 16px;
      margin: 0 auto;
      height: 80px;
      letter-spacing: 2px;
      padding: 10px;
      width: 224px;
    }
    span {
      z-index: 9999;
      display: block;
      bottom: 29px;
      right: 23px;
      position: relative;
      text-align: right;
      font-size: 16px;
      color: #cccccc;
      width: 270px;
    }
  
    .van-dialog__confirm,
    .van-dialog__confirm:active {
      color: #f9591b;
    }
  }
  .van-dialog__header {
    font-size: 18px;
    font-weight: bold;
    padding-top: 20px;
    line-height: 25px;
    height: 25px;
    text-align: center;
  }
  .dialog1 {
    .van-dialog {
      width: 280px;
      // .van-dialog__header {
      //   font-size: 18px;
      //   font-weight: bold;
      //   padding-top: 20px;
      //   line-height: 25px;
      //   height: 25px;
      //   text-align: center;
      // }

      .van-dialog__content {
        margin-bottom: 12px;
      }
      .van-button {
        font-size: 17px;
      }
    }
  }
  .dialog2 {
    .van-dialog {
      // width: 280px;
      border-radius: 8px;
      .van-dialog__content {
        .van-dialog__message {
          font-size: 16px;
          padding: 15px 0 24px;
          height: 24px;
          line-height: 24px;
        }
      }
    }
  }
  .empty {
    margin: 64px 48px 0;
    .emptyMsg {
      text-align: center;
      width: 100%;
      height: 100%;
      .tip {
        color: #999;
        font-size: 16px;
        margin-top: 15px;
      }
    }
  }
  .empty-placehoder {
    width: 100%;
    height: 12px;
    background-color: #f5f6f7;
    position: relative;
    z-index: 9999;
  }

  .loading5 {
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    img {
      width: 35%;
      margin-top: 65%;
    }
  }

      // 新增upload修改
      .van-uploader__wrapper {
        flex-wrap: nowrap;
      }
      .van-uploader__preview-delete {
        position: absolute;
        top: 0px;
        right: 0px;
        color: #fff;
        font-size: 16px;
        // padding: 3px;
        background-color: rgba(0, 0, 0, 0.6);
        border-radius: 0px 3px 0px 3px;
      }
      .van-icon-clear:before {
        content: "\F042";
      }
      .van-uploader__preview-image {
        border-radius: 3px !important;
      }

}
.red-text{
  color: #f9591b;
}


</style>